export const STATS_LEADERS_CATEGORY = {
    KEY_STATS: 'Key Stats',
    GENERAL_PLAY: 'General Play',
    DISPOSALS: 'Disposals',
    POSSESSIONS: 'Possessions',
    STOPPAGES: 'Stoppages',
    MARKS: 'Marks',
    SCORING: 'Scoring',
    DEFENCE: 'Defence',
};

export const STATS_LEADERS_CATEGORY_ARRAY = [
    STATS_LEADERS_CATEGORY.KEY_STATS,
    STATS_LEADERS_CATEGORY.GENERAL_PLAY,
    STATS_LEADERS_CATEGORY.DISPOSALS,
    STATS_LEADERS_CATEGORY.POSSESSIONS,
    STATS_LEADERS_CATEGORY.STOPPAGES,
    STATS_LEADERS_CATEGORY.MARKS,
    STATS_LEADERS_CATEGORY.SCORING,
    STATS_LEADERS_CATEGORY.DEFENCE,
];